import { message } from 'antd';
import Place from './Place'
import { connect } from 'react-redux'
import { reduxForm, submit } from 'redux-form'

import { createFavoritePlace } from './actions'

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {icon_name: "Marker"},
    title: `New Favorite Place`,
    buttonTitle: 'Save',

    // overrides from TripList > NameThisPlace modal
    ...ownProps,
    hideTitleBar: ownProps.initialValues && ownProps.initialValues.addedOnTripList
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onRemoteSubmit: ()=> dispatch(submit('favoritePlace'))
  }
}

const New = reduxForm({
  form: 'favoritePlace',
  onSubmit: (values, dispatch)=> dispatch(createFavoritePlace(values))
})(Place)
export default connect(mapStateToProps, mapDispatchToProps)(New)



// WEBPACK FOOTER //
// ./src/account/favorite-places/New.js